import { render } from "./MenuSidebar.vue?vue&type=template&id=5540fcbc&scoped=true"
import script from "./MenuSidebar.vue?vue&type=script&lang=js"
export * from "./MenuSidebar.vue?vue&type=script&lang=js"

import "./MenuSidebar.vue?vue&type=style&index=0&id=5540fcbc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5540fcbc"]])

export default __exports__